const trainingsMode = {
  DisplayCourses: 0,
  NewCourse: 1,
  EditCourse: 2,
  ViewCourse: 3
};

export { trainingsMode };
